import { ReactComponent as WarningHexIcon } from '@bonhams1793/bonhams-assets/assets/svg/icons/warningHex.svg'

import { FireStyledLargeErrorText } from './FireFormInput.styles'

export const FireFormLargeError = ({
  key,
  errorText,
}: FireFormLargeErrorProps) => (
  <FireStyledLargeErrorText key={key} as="div">
    <WarningHexIcon width="25" height="25" />
    <div>{errorText}</div>
  </FireStyledLargeErrorText>
)

interface FireFormLargeErrorProps {
  key: string | number
  errorText: string
}
